import React from 'react';

const GeneralInstruction = () => {
  return (
    <div>
      GeneralInstruction
      GeneralInstruction
    </div>
  );
}

export default GeneralInstruction;
